// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"d1","pgSpeechBox":"d1","speech-list-box":"d2","speechListBox":"d2"};